const googleTagManagerGroup = window.app_config?.googleTagManagerGroup || 'C0004';

let gtmLoaded = false;

function loadGoogleTagManager() {
    if (gtmLoaded) return;
    gtmLoaded = true;

    (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-WNVCJXK');
}

// Returning visitors who already consented: load as soon as OneTrust is ready.
window.optanonReady().then(({ OptanonActiveGroups }) => {
    if (OptanonActiveGroups?.includes(googleTagManagerGroup)) loadGoogleTagManager();
});

// First-time visitors: load the moment they grant consent, without waiting for a page reload.
window.addEventListener('OneTrustGroupsUpdated', ({ detail: OptanonActiveGroups }) => {
    if (OptanonActiveGroups?.includes(googleTagManagerGroup)) loadGoogleTagManager();
});
